import Link from 'next/link';
import Cartcount  from  "./cartcount";

import {WEBSERVER} from "../services/globals";

const CONTACT_FORM  =  WEBSERVER + '/contact-form'

const Header = () => {
  return (
    <div className="header-top d-flex flex-row justify-content-center bg-info">
      <ul className="horizontal">
        <li className="d-flex align-items-start"><a href={WEBSERVER} className="text-dark" title="Home">Home<i className="bi-house-fill text-dark" title="home"></i></a></li>
        <li className="d-flex"><i className="bi-telephone-fill" title="telephone"></i> 02166 123456789</li>
        <li className="d-flex">frei ab 49 EUR</li>
        <li className="d-flex"><a href={CONTACT_FORM} className="text-dark">Kontakt <i className="bi bi-info-square-fill text-dark"></i></a></li>
      </ul>
  </div>
  );
};

export default Header;
